
import { SectionWithVideoStepperProps } from './query';
import VideoStepper from '@/components/blocks/VideoStepper';
import Title_v2 from '@/components/molecules/Title/index';
import { renderUnderline } from '@/utilities/functions';

const SectionWithVideoStepper = ({ sectionWithVideoStepperData }: {
	sectionWithVideoStepperData: SectionWithVideoStepperProps,
}) => {
	return (
		<>
			<Title_v2
				align={sectionWithVideoStepperData.title.alignedAt}
				underlineColor={sectionWithVideoStepperData.title.underlineColor}
			>
				{renderUnderline(sectionWithVideoStepperData.title.titlePieces)}
			</Title_v2>
			<VideoStepper
				videoSteps={sectionWithVideoStepperData.videoSteps}
				description={sectionWithVideoStepperData.description}
				buttons={sectionWithVideoStepperData.buttons}
			/>
		</>
	);
};

export default SectionWithVideoStepper;
